import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
	CurrencyAmountPipe,
	DollarShorthandPipe,
} from '@marmon/frontend/common';
import { TuiHint } from '@taiga-ui/core';
import { AnalysisCardComponent } from '../analysis-card/analysis-card.component';
import { DistributionBoxComponent } from '../box-distribution-card/distribution-box/distribution-box.component';
import {
	AnalysisColorCode,
	BoxDistributionCardBaseComponent,
	ColorCodeOptions,
} from './box-distribution-card-base.component';

@Component({
	standalone: true,
	imports: [
		AnalysisCardComponent,
		TuiHint,
		TranslocoPipe,
		CurrencyAmountPipe,
		DistributionBoxComponent,
		DollarShorthandPipe,
	],
	selector: 'mar-quad-box-distribution-card',
	templateUrl: 'box-distribution-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'contents' },
})
export class QuadBoxDistributionCardComponent extends BoxDistributionCardBaseComponent {
	override readonly targets = () =>
		({ 0: 0.64, 1: 0.16, 2: 0.16, 3: 0.04 }) as const;

	/**
	 * The default way we determine what the color code thresholds should be
	 * for the distribution cards.
	 *
	 * @note this can be overridden in cards that extend off of this class to alter
	 * how the color codes are determined.
	 */
	override getColorCode(options: ColorCodeOptions): AnalysisColorCode {
		const { target, value, box } = options;
		if (target == null || value == null || box == null) {
			console.error('Color code could not be determined');
			return 'gray';
		}

		const delta = value - target;
		switch (box) {
			case 0:
				if (delta >= 0) return 'green';
				if (delta >= -0.02) return 'yellow';
				return 'red';
			case 1:
			case 2: {
				const absDelta = Math.abs(delta);
				if (absDelta <= 0.01) return 'green';
				if (absDelta <= 0.02) return 'yellow';
				return 'red';
			}
			case 3:
				if (delta <= 0) return 'green';
				if (delta <= 0.01) return 'yellow';
				return 'red';
			default:
				return 'gray';
		}
	}
}
